const e = "styles-module__menuItemDropdown___exhI6", o = "styles-module__innerWrapper___mir35", n = "styles-module__dropdownGrid___g7NT4", _ = "styles-module__dropdownImageWrapper___IkHdh", t = "styles-module__areaOfLawImageContainer___-8zLz", s = "styles-module__menuDropdownBGIcon___eUOAB", a = "styles-module__areaOfLawImage___X9yyo", r = "styles-module__defaultImage___-nQpJ", d = "styles-module__mainMenuLink___uNbHy", m = "styles-module__areasMenuModal___Rmxrs", l = "styles-module__closeWrapper___jiEyK", u = "styles-module__closeButton___BHG-Y", p = "styles-module__hidden___zm9iW", i = "styles-module__activeIcon___PQK-7", c = "styles-module__modalContent___kC3-s", I = "styles-module__areasList___K-Z9Y", w = "styles-module__mobileBGIcon___W3HZq", y = "styles-module__headingContainer___6HRLX", g = "styles-module__arrowIcon___HfelO", D = "styles-module__pageTitle___zZ38P", L = "styles-module__menuDropdownItem___RuGGa", W = "styles-module__menuDropdownItemTitle___Z7Iua", T = "styles-module__menuDropdownItemDescription___oDMyr", G = "styles-module__menuDropdownItemTitleWrapper___LilM0", f = "styles-module__gradientText___0aQdb", B = {
  menuItemDropdown: e,
  innerWrapper: o,
  dropdownGrid: n,
  dropdownImageWrapper: _,
  areaOfLawImageContainer: t,
  menuDropdownBGIcon: s,
  areaOfLawImage: a,
  defaultImage: r,
  mainMenuLink: d,
  areasMenuModal: m,
  closeWrapper: l,
  closeButton: u,
  hidden: p,
  activeIcon: i,
  modalContent: c,
  areasList: I,
  mobileBGIcon: w,
  headingContainer: y,
  arrowIcon: g,
  pageTitle: D,
  menuDropdownItem: L,
  menuDropdownItemTitle: W,
  menuDropdownItemDescription: T,
  menuDropdownItemTitleWrapper: G,
  gradientText: f
};
export {
  i as activeIcon,
  a as areaOfLawImage,
  t as areaOfLawImageContainer,
  I as areasList,
  m as areasMenuModal,
  g as arrowIcon,
  u as closeButton,
  l as closeWrapper,
  B as default,
  r as defaultImage,
  n as dropdownGrid,
  _ as dropdownImageWrapper,
  f as gradientText,
  y as headingContainer,
  p as hidden,
  o as innerWrapper,
  d as mainMenuLink,
  s as menuDropdownBGIcon,
  L as menuDropdownItem,
  T as menuDropdownItemDescription,
  W as menuDropdownItemTitle,
  G as menuDropdownItemTitleWrapper,
  e as menuItemDropdown,
  w as mobileBGIcon,
  c as modalContent,
  D as pageTitle
};
